<template>
    <div class="nouvelles">
        <header page-transition-group>
            <HeroGraphicText v-if="contentIsLoaded" />
        </header>

        <div v-if="contentIsLoaded" class="page-content pt-5" page-transition-group>

            <section
                v-for="(blogSection, index) in content.allBlog"
                :key="'blogtype-' + index"
            >
                <div v-if="blogSection.EntriesQt > 0" class="container-xxl padding-container-sm-top padding-container-bottom ">
                    <div class="row">
                        <div class="col-12">
                            <h3>{{ blogSection.title }}</h3>
                            <div class="sep-hor-black-thick mb-5"></div>
                        </div>
                    </div>

                    <div class="row">
                        <NewsCard
                            v-for="(news, index) in blogSection.blogEntries"
                            :key="'blog-news-' + index"
                            :newsData="news"
                            :showColumn="true"
                        />
                    </div>

                    <div
                        v-if="blogSection.EntriesQt > 4"
                        class="row justify-content-center"
                    >
                        <div class="col-auto">
                            <a :href="'blogue-categorie/' + blogSection.slug" class="button secondary mt-4">
                                {{ $t('Voir plus de publications de type' + ' ' + blogSection.title) }}
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
// import IconInis from '@/components/svgs/IconInis'
import { mapState, mapGetters, mapActions } from 'vuex'
import HeroGraphicText from '@/components/hero/HeroGraphicText.vue'

import NewsCard from '@/components/loopTemplate/NewsCard'

export default {
    name: 'Blogue',
    components: {
        HeroGraphicText,
        // IconInis,
        NewsCard,
    },
    data() {
        return {
        }
    },
    watch: {
        pageIsLoaded: {
            async handler(pageIsLoaded) {
                if (pageIsLoaded) {
                    // Page loaded with Data
                    this.setBgTheme(this.content.heroGraphicText.heroBackgroundColor)
                }
            },
            immediate: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg', 'setBgTheme']),
    },
}
</script>

<style lang="scss"></style>
